import { Component, ElementRef, NgZone, ViewChild } from '@angular/core'
import { GetExcel } from '../../get.excel'
import { FileUploader } from 'ng2-file-upload'
const URL = '../api/UploadAppointments'

@Component({
    selector: 'UploadAppointments',
    templateUrl: 'Upload-Appointments.component.html'
})
export class UploadAppointmentsComponents {
    public uploader: FileUploader = new FileUploader({ url: URL, itemAlias: 'licenseExcel' })

    Messages: any
    ErrorMessage: string | null
    successOrErrorMessage: string
    validateeContract = false
    errorlist: any[]
    errorlists: any[]
    isFormValid: boolean
    isFormServiceValidationValid: boolean
    response: string
    errors: any[]
    SuccessMsg: boolean
    showErrors: boolean
    SuccessMessage: string | null
    FileName: string | null
    checkMessage: string
    Warnings: any[]
    ifWarnings: boolean
    public loading: boolean = false
    @ViewChild('fileInput', { static: true }) fileInput: any

    constructor(private getExcel: GetExcel, private el: ElementRef, private ngZone: NgZone) {
        this.getExcel = getExcel
        let self = this
        this.uploader.onErrorItem = this.ngZone.run(() => (item, response, status, headers) => {
            let error: any = JSON.parse(response)
            self.errors = error.errors
            this.ifWarnings = false
        })

        this.uploader = new FileUploader({ url: URL, itemAlias: 'licenseExcel' })

        this.uploader.response.subscribe(
            (res) => ((this.response = res), console.log(this.response), (this.loading = false), this.handleResponse(this.response))
        )
        this.uploader.onAfterAddingFile = (fileItem) => {
            fileItem.withCredentials = false
            console.log(fileItem) // fileItem is the file object
        }

        this.uploader.onCompleteAll = () => {
            this.fileInput.nativeElement.value = ''
        }
    }

    getFile() {
        document.getElementById('upfile')!.click()
    }
    sub(obj) {
        this.FileName = null
        var file = obj.fileInput.nativeElement.value
        var fName = file.split('\\')
        this.FileName = fName[fName.length - 1]
        event?.preventDefault()
    }

    handleResponse(response: string) {
        this.SuccessMsg = false
        this.showErrors = false
        this.SuccessMessage = null
        this.ErrorMessage = null
        this.Messages = ''
        this.Warnings = [] as any[]
        if (response != null) {
            response = response.substring(2).slice(0, -2)
            this.Messages = response.split('",')
        }

        // if (this.response.indexOf("State License Upload Successfully") >= 0) {
        for (let i = 0; i < this.Messages.length; i++) {
            this.checkMessage = this.Messages[i]
            if (this.checkMessage.indexOf('State License Upload Successfully') >= 0) {
                this.SuccessMsg = true
                if (this.SuccessMessage == null) {
                    this.SuccessMessage = this.Messages[i]
                } else {
                    this.SuccessMessage = this.SuccessMessage.concat(this.Messages[i].slice(1))
                }
            } else if (this.checkMessage.indexOf('Warning Message: Following license number does not match with current license in database') >= 0) {
                this.ifWarnings = true
                this.Warnings.push(
                    this.Messages[i].replace('"Warning Message: Following license number does not match with current license in database: ', '')
                )

                //if (this.Warnings == null) {

                //    this.Warnings = this.Messages[i].replace("Warning Message: Following license number does not match with current license in database", '')
                //}
                //else {
                //    this.Warnings = this.Warnings.concat(this.Messages[i].replace("Warning Message: Following license number does not match with current license in database", '').slice(1))
                //}
            } else {
                this.loading = false
                this.showErrors = true
                if (this.ErrorMessage == null) {
                    this.ErrorMessage = this.Messages[i]
                } else {
                    this.ErrorMessage = this.ErrorMessage.concat(this.Messages[i].slice(1))
                }
            }

            // this.confirmationFile = this.Messages[this.Messages.length - 1].slice(1);
        }
        //   }
        //else {
        //    for (let i = 0; i < this.Messages.length; i++) {
        //        this.showErrors = true

        //    }
        //}
        //if (response.indexOf("State License Upload Successfully") >= 0) {

        //}
    }

    downlaodExcelTemplate() {
        this.loading = true
        this.getExcel.getSpreadsheet().subscribe(
            (data) => {
                if ((window.navigator as any).msSaveOrOpenBlob)
                    (window.navigator as any).msSaveBlob(data, 'SilverScript_Template_LicenseState_02062024.xlsx')
                else {
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(data)
                    link.download = 'SilverScript_Template_LicenseState_02062024.xlsx'
                    document.body.appendChild(link)
                    link.click()
                    window.setTimeout(function () {
                        window.URL.revokeObjectURL(link.href)
                        document.body.removeChild(link)
                    }, 100)
                }
                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
    }

    uploadClick() {
        this.loading = true
        this.uploader.uploadAll()
    }
}
